import tacHelpers from '../tacHelpers';

function getOffset(parent, child, model) {
  const leggedParent = parent.logic && parent.logic.floor && child.y < 0;

  if (!leggedParent) {
    return false;
  }

  const grandParent = model && tacHelpers.getParent(model, parent);
  const flooredGrandParent =
    !grandParent || !grandParent.logic || !grandParent.logic.floor;

  return flooredGrandParent;
}

export default function makeSpaceForChild(child, parent, model) {
  const offset = getOffset(parent, child, model);

  if (offset) {
    parent.y = -child.y;
  }

  if (child.items) {
    child.items.forEach(item => {
      makeSpaceForChild(item, child, model);
    });
  }
}
